function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as pintuanApi from '@/api/pintuanApi';
export default {
  data: function data() {
    return {
      loading: false,
      visible: false,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      constants: this.$constants,
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      selectIds: [],
      customerId: null
    };
  },
  mounted: function mounted() {},
  methods: {
    openInit: function openInit(customerId) {
      this.customerId = customerId;
      this.visible = true;
      this.handlerGetListData(this.listPram);
    },
    handerSubmit: function handerSubmit() {
      var _this = this;
      pintuanApi.saveCtmPinSkus({
        customerId: this.customerId,
        selectedSkuInfos: this.selectIds
      }).then(function (res) {
        _this.visible = false;
        _this.$emit('doRefresh');
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    // 搜索
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      pintuanApi.getCtmPinSkus(_objectSpread(_objectSpread({}, pram), {}, {
        customerId: this.customerId
      })).then(function (data) {
        _this2.listData = data;
        _this2.listLoading = false;
        setTimeout(function () {
          if (_this2.value && _this2.value.length) {
            var _data$list = data.list,
              list = _data$list === void 0 ? [] : _data$list;
            _this2.value.forEach(function (row) {
              var idx = list.findIndex(function (item) {
                return item.id == row.id;
              });
              _this2.$refs.tableListRef.toggleRowSelection(data.list[idx]);
            });
            _this2.selectIds = _this2.value || [];
          }
          ;
        }, 100);
      }).catch(function (err) {
        _this2.listLoading = false;
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // // 多选框选中数据
    handleSelectionChange: function handleSelectionChange() {
      var selection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.selectIds = selection;
    },
    changePrice: function changePrice() {}
  }
};